"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
    position: relative;
    padding: 97px 0 95px;
    overflow: hidden;

    > .inner {
        max-width: ${({theme:t})=>t.widths.small};
        margin: 0 auto;
        padding: 0 ${({theme:t})=>t.spacing.large};
        display: grid;
        grid-row-gap: 40px;

        @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
            max-width: ${({theme:t})=>t.widths.large};
            grid-template-columns: 1fr 1fr;
            grid-row-gap: 0;
            padding: 0 ${({theme:t})=>t.spacing.large};
        }

        > picture {
            position: relative;
            width: 100%;
            height: 0;
            padding-top: 86%;
            grid-row: 1;

            @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                grid-column: ${({isReversed:t})=>t?2:1};
                grid-row: 1;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }

            svg {
                &.icon-blob {
                    position: absolute;
                    width: 100%;
                    height: auto;
                    opacity: 0.1;

                    ${({isReversed:t,theme:e,color:i})=>t?`\n            bottom: 0;\n            right: 0;\n            transform: rotate(180deg) translate3d(-20%, -30%, 0);\n            \n            path {\n              fill: ${i||e.colors.tertiary.light};\n            }\n          `:`\n            top: 0;\n            left: 0;\n            transform: translate3d(-20%, -30%, 0);\n\n            path {\n              fill: ${i||e.colors.tertiary.default};\n            }\n          `}
                }

                &.icon-play_button {
                }
            }

            .play_button {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
                background: transparent;
                border: none;
                cursor: pointer;
            }
        }

        > .content {
            position: relative;

            @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                grid-row: 1;
                grid-column: ${({isReversed:t})=>t?1:2};
                padding: ${({isReversed:t})=>t?"32px 131px 0 33px":"32px 70px 0 54px"};
            }

            .icon-blobOutline {
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                color: ${({color:t})=>t};
                transform: translate3d(-25%, -30%, 0);
                opacity: 0.1;

                @media (min-width: ${({theme:t})=>t.breakpoints.large}) {
                    display: block;
                }
            }

            > .icon {
                height: 54px;
                width: 54px;
                border-radius: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                overflow: hidden;
                color: ${({theme:t,iconColor:e})=>e||t.colors.primary.default};
                margin-bottom: 20px;

                svg {
                    margin: 0 auto;
                    position: relative;
                    width: 27px;
                    height: auto;

                    path {
                        fill: currentColor;
                    }
                }

                &::after {
                    display: block;
                    content: '';
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: currentColor;
                    opacity: 0.1;
                }
            }

            h2 {
                margin: 0;
            }

            p {
                margin: 1em 0;

                &.subTitle {
                    margin: 5px 0 0 0;
                }
            }

            .DXLinkArrow {
                color: ${({theme:t})=>t.colors.primary.default};
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styled.js.map
